import { getCardStyles } from '@quno/onboarding/src/generator/configs/componentMapper';
import {
  defaultLocale,
  localeMapper,
} from '@quno/onboarding/src/constants/locales';
import { ReviewCard } from '@quno/patient-journey/src/components/Card/Variants/ReviewCard';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import type { ReviewContainer } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';

type ReviewsProps = ReviewContainer & {
  locale: FormLocales;
};

export const Reviews = (props: ReviewsProps): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const { attributes } = props ?? {};

  const cardStyles = getCardStyles(props);

  const reviewCards = attributes?.reviewCards?.[defaultLocale];

  return (
    <Base {...props}>
      <>
        {reviewCards?.map((reviewCard, index) => {
          const { author, date, rating, text, title } =
            reviewCard?.attributes ?? {};
          const reviewRating = +(rating?.[defaultLocale] || 0);
          const reviewDate = date?.[defaultLocale];
          const footer = author?.[defaultLocale];
          const backgroundColor = cardStyles?.card.backgroundColor;
          const borderRadius = cardStyles?.card.borderRadius;
          const fontColor = cardStyles?.card.fontColor;

          return (
            <ReviewCard
              key={index}
              rating={reviewRating}
              date={reviewDate!}
              title={title}
              footer={footer}
              text={text}
              locale={locale}
              backgroundColorOverwrite={backgroundColor}
              fontColorOverride={fontColor}
              cardBorderRadius={borderRadius}
            />
          );
        })}
      </>
    </Base>
  );
};
